import getReadableDateTimeString from './getReadableDateTimeString';

const getReadableTimeString = (dateString: string) => {
  const dateTimeString = getReadableDateTimeString(dateString);

  return dateTimeString?.split?.(',')?.[1]?.slice?.(1);
};

export default getReadableTimeString;
